module.exports = __webpack_public_path__ + "ico-crypto-avax.svg?d37554b41cd1343f55f99f160aad0180";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-avax.svg
// module id = 1158
// module chunks = 2